import { useState, useEffect } from 'react';
import { Modal } from 'flowbite-react';
import ReportsAccordion from './ReportsAccordion';

const ReportsModal = ({ showModal, onClose, reports, modalTitle }) => {
  const [expandedSections, setExpandedSections] = useState(new Set());

  // Reset expanded sections when modal opens
  useEffect(() => {
    if (showModal) {
      setExpandedSections(new Set());
    }
  }, [showModal]);

  // Toggle accordion sections
  const toggleSection = (section) => {
    const newExpanded = new Set(expandedSections);
    if (newExpanded.has(section)) {
      newExpanded.delete(section);
    } else {
      newExpanded.add(section);
    }
    setExpandedSections(newExpanded);
  };

  if (!showModal) return null;

  return (
    <Modal show={showModal} onClose={onClose} size="4xl">
      <Modal.Header className="bg-gray-200 dark:bg-gray-700 border-b border-gray-300 dark:border-gray-600">
        <div className="w-full text-gray-900 dark:text-white font-semibold">
          {modalTitle || 'Reports'}
        </div>
      </Modal.Header>
      <Modal.Body className="p-6">
        <ReportsAccordion 
          reports={reports}
          expandedSections={expandedSections}
          toggleSection={toggleSection}
        />
      </Modal.Body>
    </Modal>
  );
};

export default ReportsModal;